// extracted by mini-css-extract-plugin
export default {"container":"ContactForm_container__VI2eW","form":"ContactForm_form__mB3X-","info":"ContactForm_info__xBduM"};